import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton } from '@mui/material';
import ContactInformationForm from '../../pages/registration/ContactInformation';
import CloseIcon from '@mui/icons-material/Close';

interface EditOrderContactDialogProps {
  open: boolean;
  onClose: () => void;
  orderId: string;
}

const EditOrderContactDialog: React.FC<EditOrderContactDialogProps> = ({
  open,
  onClose,
  orderId,
}) => {
  const handleSave = () => {
    // This is the onSave handler that closes the dialog
    onClose();
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { minHeight: '400px' }
      }}
    >
      <DialogTitle>
        Edit Contact Information
        <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
            }}
            >
            <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <ContactInformationForm
          type="dialog"
          orderId={orderId}
          onSave={handleSave}
        />
      </DialogContent>
    </Dialog>
  );
};

export default EditOrderContactDialog;